import { Button, Form, InputNumber } from "antd";
import { towerTicketStopAsync } from "../../../store/features/NP/network/networkAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import CustomModal from "../../common/CustomModal";

type Props = {
  open: boolean;
  handleClose: (val?: boolean) => void;
  data?: any;
};

export default function PGDisabledModal({ open, handleClose, data }: Props) {
  const dispatch = useAppDispatch();
  const { postLoading } = useAppSelector((state) => state.network);

  const onFinish = (values: any) => {
    const { siteDcVoltage } = values;

    dispatch(
      towerTicketStopAsync({
        data: { siteDcVoltage: siteDcVoltage + "v" },
        others: {
          id: data,
          reRender: handleClose,
        },
      })
    );
  };

  return (
    <CustomModal
      width={600}
      title="PG Disable"
      open={open}
      handleClose={() => handleClose()}
    >
      <div className="p-6">
        <Form
          className="custom-form hide_star_mark highlight_placeholder"
          layout="vertical"
          onFinish={onFinish}
          size="large"
        >
          <Form.Item
            label="Site Dc Voltage"
            name="siteDcVoltage"
            className="mb-4"
            rules={[
              {
                required: true,
                message: "Please enter site DC voltage",
              },
            ]}
          >
            <InputNumber
              placeholder="Enter DC Voltage"
              size="large"
              style={{ width: "100%" }}
              step={0.01}
              stringMode
            />
          </Form.Item>

          <Button
            className="mt-2"
            type="primary"
            size="large"
            htmlType="submit"
            block
            loading={postLoading}
          >
            Submit
          </Button>
        </Form>
      </div>
    </CustomModal>
  );
}
